<template>
    <div class="performanceWaybillRightContent">
        <!-- 地图容器 -->
        <div id="mapContainer" v-loading="mapLoading"></div>
        <!-- 轨迹选择 -->
        <div class="map-route-selector">
            <el-select v-model="trackType" @change="setTrackType">
                <el-option
                    v-for="(item, index) in trackTypeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <!-- 轨迹列表 -->
        <waybill-map-track-list
            :trackTypeName="trackTypeName"
            :positionList="positionList"
        ></waybill-map-track-list>
        <!-- 轨迹播放 -->
        <div id="map-controller" v-if="isShowPlayer">
            <div class="map-controller-play">
                <i
                    :class="
                        isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'
                    "
                    @click="videoPlayer"
                ></i>
            </div>
            <div class="map-controller-progress">
                <el-progress
                    :percentage="tracedInPercent"
                    :show-text="false"
                    :stroke-width="6"
                ></el-progress>
                <div class="map-controller-progress-time">
                    <div class="begin-time">{{ startTime }}</div>
                    <div class="end-time">{{ endTime }}</div>
                </div>
            </div>
            <el-button-group class="map-controller-speed-switch">
                <el-button
                    v-for="item in [1, 2, 4, 8]"
                    :key="item"
                    :type="speed === item ? 'primary' : 'default'"
                    @click="changeSpeed(item)"
                    >x{{ item }}</el-button
                >
            </el-button-group>
        </div>
        <!-- tab标签页 -->
        <waybill-map-monitor-tab
            :isShowPlayer="isShowPlayer"
            :eventList="eventList"
            :positionList="positionList"
            :ldTrackList="ldTrackList"
            :statisticsList="statisticsList"
            :taskNo="taskNo"
            :taskNoData="taskNoData"
            @getLclNodeByTaskNo="getLclNodeByTaskNo"
            @getLclPointByTask="getLclPointByTask"
        ></waybill-map-monitor-tab>
    </div>
</template>
<script>
import WaybillMapMonitorTab from './WaybillMapMonitorTab.vue';
import WaybillMap from '../util/waybillMap.js';
import { formatMapParams } from '../util/mapConfig.js';
import WaybillMapTrackList from './WaybillMapTrackList';
const trackTypeMap = new Map();
trackTypeMap
    .set('50', '综合')
    .set('1', 'APP')
    .set('6', '北斗')
    .set('34', '设备')
    .set('5', '人工');
export default {
    components: {
        WaybillMapMonitorTab,
        WaybillMapTrackList
    },
    props: {
        taskNo: {
            type: String,
            default: ''
        },
        eventList: {
            type: Array,
            default () { return []; }
        },
        positionList: {
            type: Array,
            default () { return []; }
        },
        ldTrackList: {
            type: Array,
            default () { return []; }
        },
        statisticsList: {
            type: Array,
            default () { return []; }
        },
        isShowPlayer: {
            type: Boolean
        },
        taskNoData: {
            type: Object,
            default () { return {}; }
        }
    },
    computed: {
        // 发车时间
        startTime () {
            return this.positionList[this.positionList.length - 1].trackingDate;
        },
        // 抵达时间
        endTime () {
            return this.positionList[0].trackingDate;
        }
    },
    data () {
        return {
            waybillMap: null, // waybillMap类实例对象
            mapLoading: false, // 是否加载中
            isPlaying: false, // 是否播放轨迹
            speed: 1, // 播放速度
            tracedInPercent: 0, // 播放轨迹百分比
            trackType: '50', // 轨迹来源类型
            trackTypeName: '', // 轨迹来源类型名称
            dictData: {}, // 数据字典
            trackTypeOptions: []
        };
    },
    created () {
        this.$nextTick(() => {
            this.trackTypeOptions = [...trackTypeMap].map(v => ({ label: v[1], value: v[0] }));
            this.trackTypeName = trackTypeMap.get(this.trackType);
            this.waybillMap = new WaybillMap('mapContainer');
        });
    },
    methods: {
        // 补抓专线节点回调函数
        getLclNodeByTaskNo () {
            this.$emit('getLclNodeByTaskNo');
        },
        // 补拉北斗轨迹回调函数
        getLclPointByTask() {
            this.$emit('getLclPointByTask');
        },
        /**
         * @description 初始化地图
         * @param{Object} data 当前操作列表项数据
         */
        initMap (data) {
            // 初始化地图参数
            this.initMapData(data);
            this.initMapParams(data);
        },
        initMapData (data) {
            this.waybillMap.initMap(formatMapParams(data));
            // 注册move事件处理函数
            this.waybillMap.onMove((event) => {
                this.tracedInPercent = +event.tracedInPercent.toFixed();
                if (this.tracedInPercent === 100) {
                    this.isPlaying = false;
                }
            });
        },
        initMapParams (data) {
            if (!data.positionList.length) return;
            this.isPlaying = false;
            this.tracedInPercent = 0;
            this.speed = 1;
            this.waybillMap.setSpeed(this.speed);
        },
        /**
         * @description 轨迹播放|暂停
         */
        videoPlayer () {
            this.isPlaying = !this.isPlaying;
            if (this.isPlaying) {
                this.waybillMap.start();
            } else {
                this.waybillMap.pause();
            }
        },
        // 设置播放速度
        /**
         * @description 设置轨迹播放速度
         * @param{String} speed 播放速度
         */
        changeSpeed (speed) {
            this.speed = speed;
            this.waybillMap.setSpeed(speed);
        },
        /**
         * @description 设置轨迹来源类型
         */
        setTrackType (data) {
            this.$emit('getTrackType', data);
        }

    },
    watch: {
        // 监听轨迹类型的切换
        trackType: {
            handler (val) {
                this.trackTypeName = trackTypeMap.get(val);
            }
        }
    }
};
</script>
<style>
.performanceWaybillRightContent .BMap_stdMpPan {
    display: block !important;
}
.performanceWaybillRightContent .BMap_stdMpZoom {
    top: 50px;
}
</style>
<style scoped lang="less">
.performanceWaybillRightContent {
    height: 100%;
    width: calc(100% - 280px);
    background-color: pink;
}
#mapContainer {
    height: 60%;
    background-color: #fff;
}
#map-controller {
    display: flex;
    justify-content: space-between;
    padding: 12px 18px 6px;
    background-color: #f5f5f5;
    .map-controller-play {
        display: inline-block;
        font-size: 25px;
    }
    .map-controller-progress {
        flex-grow: 1;
        padding: 12px 14px 0;
        .map-controller-progress-time {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #666;
            margin-top: 4px;
        }
    }
    .map-controller-speed-switch {
        .el-button {
            width: 35px;
            padding: 7px 10px;
        }
    }
}
.performanceWaybillRightContent {
    position: relative;

    .map-route-selector {
        position: absolute;
        top: 0;
        right: 5px;
        z-index: 999;
    }
}
</style>
